import img2 from "../../Images/img2.png";
// import R_Logo from './R_Logo.png'
import { Link } from "react-router-dom";
import "./Customer.css";
import { useState, useRef, useEffect, useMemo } from "react";
import { variableName } from "../../variableName";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export default function HeaderCustomer() {
    const [visible, setVisible] = useState(false);
    const [showUserDetail, setShowUserDetail] = useState(false);

    //const history = useHistory();
    function logout() {
        window.localStorage.removeItem("user-info");
        window.localStorage.removeItem("app-type");
        //history.push('/Customer');
        window.location.href = "/";
    }
    const refOne = useRef(null);

    useEffect(() => {
        // document.addEventListener("click", hideOnClickOutside, true)
        // return () => {
        //     document.removeEventListener("click", hideOnClickOutside, true)
        // }
    }, []);

    const hideOnClickOutside = (e) => {
        if (refOne.current && !refOne.current.contains(e.target)) {
            console.log("Outside");
            setVisible(false);
        }
    };

    const [scrollPosition, setScrollPosition] = useState(0);

    const handleScroll = (event) => {
        const { scrollLeft } = event.target;
        setScrollPosition(-scrollLeft);
    };

    // useEffect(() => {

    //     console.log({ visible });
    //     return () => {

    //     }
    // }, [visible])
    const userInfo = useMemo(
        () =>
            localStorage.getItem("user-info")
                ? JSON.parse(localStorage.getItem("user-info"))
                : null,
        []
    );

    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const isReportsActive = location.pathname.startsWith("/reports");



    return (
        <>
            <nav className="top-nav">

                <Link to="/" className="nav-left" >
                    <img src={img2} className="newLogo" alt="Logo" />
                    <h2 className="brand-name" style={{ textDecoration: "none" }}>{variableName.outerHeaderName}</h2>
                </Link>

                {/* HAMBURGER (mobile) */}
                <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                    ☰
                </div>

                {/* CENTER MENU */}
                <ul className={`nav-center ${menuOpen ? "open" : ""}`}>
                    <li>
                        <NavLink className="nav-link"
                            to="/components/customer/CustomerDashboard"
                            style={{ textDecoration: "none" }}
                        >
                            <li>Order</li>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink className="nav-link" to="/OrderUpload/" style={{ textDecoration: "none" }}>
                            <li className=" ">Order Upload</li>
                        </NavLink>
                    </li>
                    <li>    <NavLink className="nav-link"
                        to="/components/customer/OrderByComp_Customer"
                        style={{ textDecoration: "none" }}
                    >
                        <li>Order by Comp </li>
                    </NavLink>
                    </li>
                    <li>
                        <NavLink className="nav-link"
                            to="/components/customer/Ledger"
                            style={{ textDecoration: "none", }}
                        >
                            <li
                            >
                                View ledger
                            </li>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink className="nav-link"
                            to="/components/customer/PendingBills"
                            style={{ textDecoration: "none", }}
                        >
                            {" "}
                            <li
                            >
                                Pending bills{" "}
                            </li>
                        </NavLink>

                    </li>
                    <li>
                        <NavLink className="nav-link"
                            to="/components/customer/DownLoadInvoice"
                            style={{ textDecoration: "none", }}
                        >
                            <li>
                                Download Invoice
                            </li>
                        </NavLink>

                    </li>
                    <li className={`dropdown ${isReportsActive ? "active" : ""}`}>
                        <span className="nav-link">Reports ▾</span>


                        <ul className="dropdown-menu">
                            <li>
                                <NavLink className="nav-link"
                                    to="/components/customer/OrderList"
                                    style={{ textDecoration: "none", }}
                                >
                                    {" "}
                                    <span

                                    >
                                        Order List
                                    </span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="nav-link"
                                    to="/components/customer/BounceList"
                                    style={{ textDecoration: "none", }}
                                >
                                    {" "}
                                    <span
                                    >
                                        Bounce List{" "}
                                    </span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className="nav-link"
                                    to="/components/customer/BillTracking"
                                    style={{ textDecoration: "none", }}
                                >
                                    {" "}
                                    <span
                                    >
                                        Bill Tracking
                                    </span>
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                </ul>

                <div className="nav-right">
                    <button className="logout-btn" onClick={logout}>Logout</button>
                </div>

            </nav>
            <div className="col-md-12  d-flex justify-content-center  align-items-end">
                <div>
                    {userInfo ? "Welcome: " + userInfo.name : ""}
                    <br />
                    <div style={{
                        display: "flex",
                        justifyContent: "space-evenly"
                    }}>
                        <span>{userInfo ? " Code: " + userInfo.code : ""}</span>
                        <span>{userInfo ? " Place: " + userInfo.place : ""}</span>
                    </div>
                </div>
            </div>
            {/* <br /> */}



            {/* <div className=" mainLogin">
                <div className="row m-0">
                    <div className="col-md-2 col-3">
                        <Link to="/">
                            <img
                                src={img2}
                                height={100}
                                width={"auto"}
                                id="S"
                                alt=""
                                style={{ marginTop: "5px" }}
                            />
                        </Link>

                    </div>
                    <div className="col-md-6 col-9" style={{
                        display: "flex",
                        alignItems: "center"
                    }}>
                        <h1 className="pl-lg-3 headerH1 text-center mb-0">
                            {variableName.outerHeaderName}
                        </h1>
                    </div>
                    <div className="col-md-4 d-flex justify-content-end  align-items-end">
                        <div>
                            {userInfo ? "Welcome: " + userInfo.name : ""}
                            <br />
                            <div className="text-end">
                                {userInfo ? "  " + userInfo.place : ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="Cust-Order-list" onScroll={handleScroll}>
                <Link
                    to="/components/customer/CustomerDashboard"
                    style={{ textDecoration: "none" }}
                >
                    <li>Order</li>
                </Link>
                <Link to="/OrderUpload/" style={{ textDecoration: "none" }}>
                    <li className=" ">Order Upload</li>
                </Link>
                <Link
                    to="/components/customer/OrderByComp_Customer"
                    style={{ textDecoration: "none" }}
                >
                    <li>Order by Comp </li>
                </Link>
                <span
                    onMouseLeave={() => {
                        // console.log("Leaved");
                        setVisible(false);
                        // setShowUserDetail(true)
                    }}
                >
                    <li
                        onMouseEnter={() => {
                            // console.log("Entered");
                            setVisible(true);
                            setShowUserDetail(false);
                        }}
                        to=" "
                        onClick={() => {
                            // console.log({ showUserDetail, visible });
                            setShowUserDetail(!showUserDetail);
                            setVisible(!visible);
                        }}
                        style={{
                            color: "black",
                            marginTop: "0px",
                            padding: "10px",
                        }}
                    >
                        Reports
                    </li>

                    {visible && (
                        <div
                            className="Dreport_list"
                            onMouseLeave={() => setVisible(false)}
                            ref={refOne}
                            style={{
                                transform: `translateX(${scrollPosition}px)`,
                            }}
                        >
                            <Link
                                to="/components/customer/Ledger"
                                style={{ textDecoration: "none", color: "white" }}
                            >
                                <p
                                    className="list_reports"
                                    style={{ padding: "5px 0px 5px 10px" }}
                                >
                                    View ledger
                                </p>
                            </Link>
                            <Link
                                to="/components/customer/PendingBills"
                                style={{ textDecoration: "none", color: "white" }}
                            >
                                {" "}
                                <p
                                    className="list_reports"
                                    style={{ padding: "5px 0px 5px 10px" }}
                                >
                                    Pending bills{" "}
                                </p>
                            </Link>
                            <Link
                                to="/components/customer/DownLoadInvoice"
                                style={{ textDecoration: "none", color: "white" }}
                            >
                                <p
                                    className="list_reports"
                                    style={{ padding: "5px 0px 5px 10px" }}
                                >
                                    {" "}
                                    Download <br />
                                    Invoice
                                </p>
                            </Link>
                            <Link
                                to="/components/customer/OrderList"
                                style={{ textDecoration: "none", color: "white" }}
                            >
                                {" "}
                                <p
                                    className="list_reports"
                                    style={{ padding: "5px 0px 5px 10px" }}
                                >
                                    Order List
                                </p>
                            </Link>
                            <Link
                                to="/components/customer/BounceList"
                                style={{ textDecoration: "none", color: "white" }}
                            >
                                {" "}
                                <p
                                    className="list_reports"
                                    style={{ padding: "5px 0px 5px 10px" }}
                                >
                                    Bounce List{" "}
                                </p>
                            </Link>
                            <Link
                                to="/components/customer/BillTracking"
                                style={{ textDecoration: "none", color: "white" }}
                            >
                                {" "}
                                <p
                                    className="list_reports"
                                    style={{ padding: "5px 0px 5px 10px" }}
                                >
                                    Bill Tracking
                                </p>
                            </Link>
                        </div>
                    )}




                </span>

                <Link

                    style={{ textDecoration: "none" }}
                >
                    <li onClick={logout}>Log Out </li>
                </Link>

            </div> */}
        </>
    );
}
